import { hasNamespaceObject, windowNamespaceObject } from "../namespace";
/**
 * plugin registry instance is accessible under window.<lib-namespace>.pluginRegistry
 */
const PLUGIN_REGISTRY_NAMESPACE = "pluginRegistry";
/**
 * @public
 */
export class PluginRegistry {
    constructor() {
        /**
         * key = PluginName
         */
        // tslint:disable-next-line no-any
        this.plugins = {};
        this.alias = {};
        this.chains = {};
        // singleton
    }
    static getInstance() {
        if (hasNamespaceObject(PLUGIN_REGISTRY_NAMESPACE)) {
            return windowNamespaceObject(PLUGIN_REGISTRY_NAMESPACE);
        }
        return windowNamespaceObject(PLUGIN_REGISTRY_NAMESPACE, new PluginRegistry());
    }
    register(name, fn) {
        this.plugins[name] = fn;
    }
    /**
     * Define an alias for a given plugin with new default options
     *
     * @param alias - the alias to register
     * @param originalPlugin - the original plugin to wrap with an alias
     * @param defaultParameter - the new default parameter to use for the defined alias
     */
    registerAlias(alias, originalPlugin, defaultParameter) {
        this.alias[alias] = {
            name: originalPlugin,
            parameter: defaultParameter
        };
    }
    registerPluginChain(alias, fn) {
        this.chains[alias] = fn;
    }
    isPluginChain(alias) {
        return !!this.chains[alias];
    }
    isAlias(alias) {
        return !!this.alias[alias];
    }
    isRegistered(plugin) {
        return (!!this.plugins[plugin] ||
            this.isAlias(plugin) ||
            this.isPluginChain(plugin));
    }
    /*
    * not implemented currently
    */
    getPluginChain(alias) {
        return this.chains[alias];
    }
    getAlias(alias) {
        return this.alias[alias];
    }
    getOrThrow(plugin, 
    // tslint:disable-next-line no-any
    errorMessage = `Plugin with name "${plugin} is not registered.`) {
        if (!this.isRegistered(plugin)) {
            throw new Error(errorMessage);
        }
        return this.plugins[plugin];
    }
}
//# sourceMappingURL=PluginRegistry.js.map